<template>
  <keep-alive>
    <div id="OrgManagementHeader" :class="`!tw-z-[1070]`">
      <div id="left">
        <a href="/dashboard" @click="onLinkToDashboard">
          <img
            class="logo tw-cursor-pointer"
            src="/img/CyberSystemLogo.svg"
            alt="LOGO"
          />
        </a>
        <span>
          <active-org-drop-down
            :status-setup-modal="statusSetupModal"
            :user-data="userPayload"
          />
        </span>
      </div>
      <div id="right">
        <global-search
          class="search"
          @on-click-input-search="onClickInputSearch"
        />
        <div class="tw-mr-[7px]">
          <notification-handler
            :notification-count="notificationCount"
            @click="emitNotification"
          />
        </div>
        <ButtonShowMore
          :id-popover="'popover-button-show-more-org-management-header'"
          :is-from-notification="true"
          dropdown-class="!tw-top-[54px] tw--min-w-[126px] tw-max-w-[252px]"
          placement="bottom-end"
        >
          <template #icon>
            <GlobalAvatar
              v-if="urlAvatar === null"
              id="menu-global-avatar-user"
              data-cy="menu-global-avatar-user"
              class="tw-cursor-pointer"
              :name="user?.fullName || user?.email"
              :class-name="'user-icon'"
            />
            <img
              v-else
              :src="urlAvatar"
              data-cy="menu-global-avatar-user"
              alt="user"
              class="user-icon"
            />
          </template>
          <div
            data-cy="app-header-nav-user-info"
            :class="`${
              planOrgDetail ? 'tw-cursor-pointer' : 'cursor-pointer-unset'
            } tw-flex tw-flex-col !tw-p-[15px] normal-text hover:tw-bg-[#F2F8FF80]`"
            @click="openProfileModal"
          >
            <span
              class="tw-text-[#211F58] tw-text-[12px] tw-font-medium tw-mb-[5px]"
            >
              {{ user?.fullName || user?.email }}
            </span>
            <span class="tw-text-[#878787] tw-text-[11px] tw-font-normal">
              {{ user?.company }}
            </span>
          </div>
          <custom-drop-down-item
            :padding="`tw-px-[15px] tw-pb-[15px]`"
            data-cy="app-header-nav-log-out"
            :style="'danger'"
            :style-text="'tw-pt-[12px]'"
            :id-text="'app-header-nav-log-out-title-1'"
            @click="logout"
          />
        </ButtonShowMore>
        <span
          :class="`${
            planOrgDetail ? 'tw-cursor-pointer' : 'cursor-pointer-unset'
          } three-dots-wrapper tw-ml-[8px]`"
          @click="emitMenuDots"
        >
          <img
            src="/img/menu_dots.svg"
            alt="menu"
            :class="`menu-icon ${
              planOrgDetail ? 'tw-cursor-pointer' : 'cursor-pointer-unset'
            }`"
          />
        </span>
      </div>
      <ProfileModal
        class="tw-px-[0px]"
        :is-visible="isProfileModalVisible"
        :is-internal="isInternal"
        :profile="user"
        :existing-profile="currentUser"
        :is-current-user="true"
        @close="closeProfileModal"
        @show-modal="openActionModal"
        @show-modal-m-f-a="showMFA"
      />
    </div>
  </keep-alive>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import store from "@/store";
import utilities from "@/utils/utilities";
import NotificationHandler from "@/components/common/notificationHandler.vue";
import ActiveOrgDropDown from "../orgManagement/activeOrgDropDown.vue";
import ButtonShowMore from "./setting/buttonShowMore.vue";
import CustomDropDownItem from "./customDropDownItem.vue";
import userService from "@/services/user/userService";
import router from "@/router";
import ProfileModal from "../orgManagement/profileModal.vue";
import {
  actionClickType,
  statusCode,
  successStatusCodes,
  MODAL_NAME,
  localStorageKey,
  SEARCH_TYPE_ID,
  DEFAULT_LANG_ID,
  localStorageBoolean,
} from "@/utils/constants";
import {
  getCurrentUser,
  getExternalMembersOrg,
  getInternalMembersOrg,
} from "@/services/org";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IMemberInfo } from "@/interfaces/members/IMember";
import GlobalSearch from "@/components/common/globalSearch/index.vue";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { getComponentUiText } from "@/utils/utilities";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { computed, ref, Ref } from "vue";
import { _resetAuthenApp } from "@/utils/handleFunctionMemberManagement";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { productFruits } from "product-fruits";
import { UserRoute } from "../../services/apiRoutes/routes";

@Component({
  components: {
    GlobalSearch,
    NotificationHandler: NotificationHandler,
    ActiveOrgDropDown: ActiveOrgDropDown,
    ButtonShowMore: ButtonShowMore,
    CustomDropDownItem: CustomDropDownItem,
    ProfileModal: ProfileModal,
    GlobalAvatar: GlobalAvatar,
  },
})
export default class OrgManagementHeader extends Vue {
  notificationCount = "0";
  currentUser = {};
  isInternal = true;
  showModal = {
    showModalPassword: {
      value: false,
      isMultiple: false,
    },
  };
  isCloseModalProfile = computed(() => store.state.User.isCloseModalProfile);
  user: any = computed(() => store.state.User.currentUser);
  urlAvatar: any = computed(() => store.state.User.urlAvatar);
  public userPayload: Ref = ref({});

  mounted() {
    this.$nextTick(async () => {
      try {
        let currentUserData;
        const res = await getCurrentUser();
        let userData = res?.data?.data || null;
        // get user profile
        const profile = await userService.getUserProfile(userData.userId);
        const profileData = profile.data.data;
        if (profileData.avatar?.avatarImageFileId) {
          const imageData = await userService.getUserProfileImage(
            profileData.avatar?.avatarImageFileId,
          );
          const file = utilities.base64ToFile(
            imageData.data.data.file,
            imageData.data.data.fileName,
            imageData.data.data.fileType,
          );
          store.commit("User/SET_AVATAR_CURRENT", URL.createObjectURL(file));
        }
        this.userPayload = userData;
        localStorage.setItem(
          localStorageKey.currentUserData,
          JSON.stringify(userData),
        );
        const languageIdStore = localStorage.getItem(
          localStorageKey.languageId,
        );
        const productFruitsInitialized = localStorage.getItem(
          localStorageKey.productFruitsInitialized,
        );
        if (userData && !productFruitsInitialized) {
          (window as any).productFruits?.services?.destroy();
          productFruits.init(
            process.env.VUE_APP_PRODUCT_FRUIT_WORDSPACE_CODE || "",
            Utils.getISOLanguageCode(languageIdStore ?? userData.languageId),
            {
              username: `${userData.firstName} ${userData.lastName}`,
            },
          );
          localStorage.setItem(
            localStorageKey.productFruitsInitialized,
            localStorageBoolean.true,
          );
        }
        const languageId = localStorage.getItem(localStorageKey.languageId);
        if (!languageId) {
          localStorage.setItem(localStorageKey.languageId, userData.languageId);
          store.dispatch(
            "LanguagePicker/setLanguages",
            localStorage.getItem(localStorageKey.recaptcha),
          );
          store.dispatch(
            "LanguagePicker/setSelectedLanguage",
            userData.languageId,
          );
        } else {
          if (languageId && languageId !== userData.languageId) {
            setTimeout(() => {
              store.dispatch("User/updateUserProfile", {
                data: { languageId: languageId || DEFAULT_LANG_ID },
              });
            }, 3000);
          }
        }

        const [external, internal] = await Promise.all([
          this.getExternalMembersList(),
          this.getInternalMembersList(),
        ]);
        if (
          external &&
          external.length > 0 &&
          external.find((member: any) => member.id === userData.userId)
        ) {
          currentUserData = external.find(
            (member: any) => member.id === userData.userId,
          );
          this.isInternal = false;
        } else {
          currentUserData =
            internal.find((member: any) => member.id === userData?.userId) ??
            {};
          this.isInternal = true;
        }

        this.currentUser = {
          fullName: currentUserData?.user?.nameText || "",
          title: currentUserData?.user?.title || "",
          company: currentUserData?.organization || "",
          email: currentUserData?.user?.email || "",
          roles: currentUserData?.roles || [],
          profilePicture: currentUserData?.user?.imgSrc || "",
          lastActive: currentUserData?.lastActive || "",
          id: currentUserData?.userId || null,
          mfaEnabled: currentUserData?.mfaEnabled || "",
          isLocked: currentUserData?.isLocked || false,
          isDeactivated: currentUserData?.isDeactivated || false,
          status: currentUserData?.status || "",
          salutationId: userData.salutationId || "",
        };
        store.commit("User/setCurrentUser", this.currentUser);
        await this.getSalutations();
        await this.getListOrgRoles();
      } catch (error: any) {
        this.showError(error.message);
        console.error(error);
      }
    });
    EventEmitter.on(EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS, () =>
      this.reFreshUserData(),
    );
  }

  onLinkToDashboard() {
    store.dispatch("Navigation/setPrimaryMenuIndex", 0);
  }

  onClickInputSearch() {
    store.dispatch("Assessment/getRecentSearches", {
      searchTypeId: SEARCH_TYPE_ID.GLOB,
    });
    store.dispatch("Recommend/fetchChecklistData");
  }

  reFreshUserData = async () => {
    try {
      let currentUserData;
      const res: any = await getCurrentUser();
      const userData = res.data.data || {};
      const external = await this.getExternalMembersList();
      if (
        external &&
        external.length > 0 &&
        external.find((member: any) => member.id === userData.userId)
      ) {
        currentUserData = external.find(
          (member: any) => member.id === userData.userId,
        );
        this.isInternal = false;
      } else {
        const internal = await this.getInternalMembersList();
        currentUserData =
          internal.find((member: any) => member.id === userData?.userId) ?? {};
        this.isInternal = true;
      }
      this.currentUser = {
        fullName: currentUserData?.user?.nameText || "",
        title: currentUserData?.user?.title || "",
        company: currentUserData?.organization || "",
        email: currentUserData?.user?.email || "",
        roles: currentUserData?.roles || [],
        profilePicture: currentUserData?.user?.imgSrc || "",
        lastActive: currentUserData?.lastActive || "",
        id: currentUserData?.userId || null,
        mfaEnabled: currentUserData?.mfaEnabled || "",
        isLocked: currentUserData?.isLocked || false,
        isDeactivated: currentUserData?.isDeactivated || false,
        status: currentUserData?.status || "",
        salutationId: userData.salutationId || "",
      };
      store.commit("User/setCurrentUser", this.currentUser);
    } catch (error) {
      console.error(error);
    }
  };

  get planOrgDetail() {
    const orgPland = store.getters["Org/getPlanDetails"];
    return orgPland && orgPland.planId ? true : false;
  }

  getExternalMembersList = async () => {
    try {
      const res = await getExternalMembersOrg();
      if (res && res.data && res.data.data) {
        if (res.data.data.length > 0) {
          res.data.data = res.data.data.map((member) => {
            member = {
              ...member,
              user: {
                nameText:
                  member.firstName === null && member.lastName === null
                    ? null
                    : `${member.firstName}${
                        member.lastName === null ? "" : " " + member.lastName
                      }`,
                title: member.title,
                email: member.email,
                imgSrc: "",
              },
              roles: member.roles || [],
              organization: member.org && member.org.orgNameShort,
              id: member.userId,
            };
            return member;
          });
        }
        EventEmitter.emit(
          EmitterEvents.EXTERNAL_MEMBERS_LOADING_COMPLETED,
          res.data.data,
        );
        return res.data.data;
      }
    } catch (error: any) {
      EventEmitter.emit(EmitterEvents.EXTERNAL_MEMBERS_LOADING_COMPLETED, []);
      showErrorAPI(error, Org.getExternalMembersOfOrg);
    }
  };
  showModalBulkActions = (data: {
    title: string;
    description: string;
    list?: string[];
    buttonText?: string;
    slotCustom?: any;
    onUpdate: () => void;
    onUpdate2?: () => void;
    buttonRed?: boolean;
    isExternal?: boolean;
    hiddenHelp?: boolean;
    submitButton?: string;
  }) => {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
      properties: {
        value: {},
        title: data.title ? getComponentUiText(data.title) : "",
        description: data.description
          ? getComponentUiText(data.description)
          : "",
        buttonText: data.buttonText ? getComponentUiText(data.buttonText) : "",
        buttonRed: !!data.buttonRed,
        slotCustom: data.slotCustom,
        hiddenHelp: data.hiddenHelp,
        submitButton: data.submitButton,
      },
      events: {
        "update:data": () => data.onUpdate(),
        "update:data2": () => data.onUpdate2?.(),
      },
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  };
  resetMfaOtherUser = () => {
    // profile.value.id is id of the user
    // call api when click button reset When not current user
  };
  resetMfaAuthenicator = () => {
    this.resetAuthenApp();
  };

  resetMfaPasskey = async () => {
    try {
      await store.dispatch("Org/resetMembersMFAPasskey");
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-members-toast-member-reset-mfa-successfully-1",
        ),
      };
      EventEmitter.emit(
        EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS,
        this.isInternal,
      );
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
      EventEmitter.emit(
        EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS,
        this.isInternal,
      );
    } catch (error: any) {
      showErrorAPI(error?.data, "reset memberMFA error");
    }
  };
  resetAuthenApp = async () => {
    const res = await _resetAuthenApp();
    if (res?.success) {
      EventEmitter.emit(
        EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS,
        this.isInternal,
      );
      EventEmitter.emit(
        EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS,
        this.isInternal,
      );
    }
  };

  resetPassKey = () => {
    // profile.value.id is id of the user
    // call api when click button reset in resetPassKey
  };
  modalConfig = {
    MFA_REGISTERED: {
      title: "app-settings-team-members-title-reset-authen-1",
      description: "app-settings-team-members-content-reset-authen-1",
      buttonText: "app-settings-team-members-profile-modal-pwd-action-button-1",
      onUpdate: this.resetAuthenApp,
    },
    MFA_REGISTERED_PK: {
      title: "app-settings-team-members-more-modal-reset-mfa-1",
      description:
        "app-user-setting-team-member-content-reset-mfa-register-pk-1",
      buttonText: "app-settings-team-members-reset-authen-button-1",
      submitButton: "app-settings-team-members-reset-passkey-button-1",
      onUpdate: this.resetMfaAuthenicator,
      onUpdate2: this.resetMfaPasskey,
    },
    MFA_REGISTERED_PKONLY: {
      title: "app-settings-team-members-reset-passkey-button-1",
      description: "app-user-setting-team-member-content-reset-pass-key-1",
      buttonText: "app-settings-team-members-profile-modal-pwd-action-button-1",
      onUpdate: this.resetMfaPasskey,
    },
  };
  showMFA = () => {
    store.commit("User/setIsCloseModalProfile", false);
    const config = this.modalConfig[this.user.value.mfaEnabled];
    // const config = this.modalConfig["MFA_REGISTERED_PKONLY"];
    if (config) {
      this.showModalBulkActions({
        ...config,
        buttonRed: true,
        hiddenHelp: false,
      });
    }
  };

  openVerifyRestPasswordModal = (data: any) => {
    this.isProfileModalVisible = false;

    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_VERIFY_RESET_PASSWORD,
      properties: {
        isCurrentUser: true,
        secretKey: data.secret,
      },
      events: {},
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  };

  doResetPassword = async (action = "", isMultiple = false) => {
    try {
      const { fullName, email } = this.user.value;

      const recaptcha = await this.getRecaptcha();

      const res = await userService.forgotPassword(email, recaptcha);

      const {
        data: {
          data: { secret },
        },
      } = res;

      if (res && res.data) {
        this.openVerifyRestPasswordModal({ secret });
        const emitData: IToastMessage = {
          variant: ToastVariant.SUCCESS,
          message: getComponentUiText(
            "app-settings-team-members-profile-toast-reset-password-1",
            false,
            { username: fullName },
          ),
        };
        EventEmitter.emit(
          EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
          emitData,
        );
      }
    } catch (error: any) {
      if (error && error.data) {
        showErrorAPI(error, Org.resetPasswordOrgMember);
      }
    }
  };

  async openActionModal(action: string) {
    store.commit("User/setIsCloseModalProfile", false);
    let emitData: IModalMessage = {
      component: "",
      properties: {},
      events: {},
    };
    switch (action) {
      case actionClickType.actionAddAnotherMFA:
        emitData = {
          component: MODAL_NAME.MFA_SELECTION_MODAL,
          properties: {
            profileData: this.user,
          },
          events: {},
        };
        break;
      case actionClickType.actionAddMFA:
        emitData = {
          component: MODAL_NAME.MFA_SELECTION_MODAL,
          properties: {
            profileData: { ...this.user, _isInternal: this.isInternal },
          },
          events: {},
        };
        break;
      case actionClickType.actionResetPassword:
        emitData = {
          component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
          properties: {
            value: {},
            title: getComponentUiText(
              "app-settings-team-members-profile-modal-pwd-action-title-1",
            ),
            description: getComponentUiText(
              "app-settings-team-members-profile-modal-pwd-action-current-user-1",
            ),
            buttonText: getComponentUiText(
              "app-settings-team-members-profile-modal-mfa-action-button-1",
            ),
            buttonRed: false,
            hiddenHelp: false,
            modalContainerClass: "tw-z-[1071]",
          },
          events: {
            "update:data": () => {
              this.isProfileModalVisible = false;
              this.doResetPassword(actionClickType.actionResetPassword, false);
            },
          },
        };
        break;
    }
    if (emitData.component) {
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
    }
  }
  getInternalMembersList = async () => {
    try {
      const res = await getInternalMembersOrg();
      if (res && res.data && res.data.data) {
        if (res.data.data.length > 0) {
          res.data.data = res.data.data.map((member) => {
            member = {
              ...member,
              user: {
                nameText:
                  member.firstName === null && member.lastName === null
                    ? null
                    : `${member.firstName} ${
                        member.lastName === null ? "" : " " + member.lastName
                      }`,
                title: member.title,
                email: member.email,
                imgSrc: "",
              } as IMemberInfo,
              status: member.isLocked
                ? statusCode.locked
                : member.isDeactivated
                  ? statusCode.deactivated
                  : statusCode.active,
              roles: member.roles || [],
              organization: member.org && member.org.orgNameShort,
              id: member.userId,
            };
            return member;
          });
        }
        EventEmitter.emit(
          EmitterEvents.INTERNAL_MEMBERS_LOADING_COMPLETED,
          res.data.data,
        );
        return res.data.data;
      }
    } catch (error: any) {
      EventEmitter.emit(EmitterEvents.INTERNAL_MEMBERS_LOADING_COMPLETED, []);
      if (error && error.data) {
        showErrorAPI(error, Org.getMembersOfOrg);
      }
    }
  };

  async emitMenuDots() {
    this.$emit("menu-dots-click");
  }

  emitNotification() {
    this.$emit("notification-click");
  }

  get statusSetupModal() {
    return store.getters["SetupWizard/isShowModal"];
  }

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  public isProfileModalVisible = false;

  getUiText(id: string, isArray = false) {
    return utilities.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  async logout() {
    await userService.logout().then(
      () => {},
      (error: any) => {
        if (error) {
          showErrorAPI(error, UserRoute.logout);
        } else {
          this.showError(
            getComponentUiText("app-exception-handler-error-unknown-error"),
          );
        }
      },
    );

    store.commit("User/SET_AVATAR_CURRENT", null);
    store.commit("Assessment/INITIAL_CHANGE_ORG_USER");
    store.commit("Recommend/INITIAL_CHANGE_ORG_USER");
    store.commit("Sharing/INITIAL_CHANGE_ORG_USER");
    router.push({ name: "Login" });
  }

  async handleShowModal(action: string) {
    if (!action) return;
    this.showModal[action] &&
      (this.showModal[action].value = true) &&
      (this.showModal[action].isMultiple = true);
  }

  openProfileModal() {
    this.getRoleByUserId(this.user.id);
    const cond = document.getElementById("pricing-table-container");
    if (cond) {
      return;
    }
    this.isProfileModalVisible = true;
  }
  getRoleByUserId(userId: string) {
    try {
      store.dispatch("Org/getRoleByUserId", userId);
    } catch (error) {
      showErrorAPI(error, Org.getRoleByUserId);
    }
  }
  closeProfileModal() {
    if (this.isCloseModalProfile) {
      this.isProfileModalVisible = false;
    } else {
      (document.activeElement as HTMLElement).blur();
      document.body.focus();
    }
  }
  async getSalutations() {
    try {
      const res = await store.dispatch("User/getSalutations");
      if (!(res.status === successStatusCodes.OK)) {
        this.showError(
          res?.data?.error?.message ||
            getComponentUiText("app-exception-handler-error-unknown-error"),
        );
      }
    } catch (error: any) {
      this.showError(error?.data?.error?.message);
    }
  }
  async getListOrgRoles() {
    try {
      const res = await store.dispatch("Org/fetchOrgRoles");
      if (!(res.status === successStatusCodes.OK)) {
        this.showError(
          res?.data?.error?.message ||
            getComponentUiText("app-exception-handler-error-unknown-error"),
        );
      }
    } catch (error: any) {
      this.showError(error?.data?.error?.message);
    }
  }
  showError(message) {
    const emitData: IToastMessage = {
      variant: ToastVariant.ERROR,
      message,
    };
    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
  }
  async getRecaptcha() {
    try {
      const finalKey = await Utils.getV3Recaptcha();
      const recaptcha = await load(`${finalKey}`, {
        autoHideBadge: true,
      });
      const token = await recaptcha.execute("submit");
      return token;
    } catch (error: any) {
      router.push({ path: "/" });
    }
  }
}
</script>

<style scoped>
#OrgManagementHeader {
  background: #0345bd;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 3;
  height: 56px;
  gap: 30px;
}

#OrgManagementHeader #left {
  display: flex;
  align-items: center;
  gap: 30px;
}
#OrgManagementHeader #left .logo {
  width: 30px;
  height: 30px;
}

#OrgManagementHeader #right {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
}

#OrgManagementHeader #right .menu-icon {
  width: 18px;
  height: 3.991px;
  cursor: pointer;
}

#OrgManagementHeader #right .user-icon {
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 50%;
  border: 0.5px solid white;
  background-color: white;
}

#OrgManagementHeader #right .three-dots-wrapper {
  padding: 10px;
  padding-left: 7px;
}

.normal-text {
  border-bottom: 1px solid #eff0f1;
  font-family: "Poppins";
}

.cursor-pointer-unset {
  cursor: unset !important;
}

#OrgManagementHeader #right .search {
  margin-right: 15px;
}
#OrgManagementHeader .action-button {
  padding: 0px !important;
  margin: 8px;
}
@media (max-width: 768px) {
  #OrgManagementHeader #right {
    margin-left: 5px;
  }
  #OrgManagementHeader #right .search {
    display: none;
  }
}

:deep(.popover-body) {
  padding: 0 !important;
}

/* :deep(.custom-popover) {
  padding: 0.5rem 0.75rem !important;
} */
</style>
